import * as d3 from '../node_modules/d3'
import * as _ from 'lodash'
import Vue from 'vue'
import ChartHeader from '../components/ChartHeader'
import data from './sex_frequency_data'

const renderResult = function (result) {
  const renderArea = d3.select('#slate-int-calculator-result')
  let resized = false

  if (result === 'clear') clearRenderArea()
  else fillRenderArea(result)

  window.addEventListener('resize', _.debounce(function () {
    resized = true
    clearRenderArea()
    fillRenderArea(result)
  }, 500))

  function clearRenderArea () {
    renderArea.selectAll('div').remove()
  }

  function fillRenderArea (result) {
    const dataCopy = JSON.parse(JSON.stringify(data))
    const ageCategories = ['18 to 23', '24 to 29', '30 to 39', '40 to 49', '50 to 64', '65 and over']
    const ageIds = data.partner_age[0].map((obj) => obj.group)
    const freqCategories = ['Not at all', 'Once or twice', 'Monthly', 'Two or three times a month', 'Weekly', 'Two or three times a week', 'Four or more times a week']
    const partnerCategories = ['without a regular sex partner', 'with a regular sex partner']

    let ageGroup = result.ageValue
    let hasPartner = result.partnerValue
    let userFreq = result.freqValue

    const buttons = ['', 'See data for all respondents', `See data for respondents ${partnerCategories[hasPartner]}`, 'See data for just your age group', `See data for respondents ${partnerCategories[hasPartner]}, by age group`, `See data for respondents ${partnerCategories[1 - hasPartner]}, by age group`, '']

    let currentSlide = 0
    let header

    const slideData = [
      {
        data: dataCopy.all,
        multiple: false
      },
      {
        data: dataCopy.partner[hasPartner],
        multiple: false
      },
      {
        data: dataCopy.partner_age[hasPartner][ageGroup],
        multiple: false
      },
      {
        data: dataCopy.partner_age[hasPartner],
        multiple: true
      },
      {
        data: dataCopy.partner_age[1 - hasPartner],
        multiple: true
      }
    ]
    let activeData = slideData[currentSlide].data

    renderArea.append('div')
      .attr('id', 'slate-int-calculator-chart-header')
    const chartArea = renderArea.append('div')
      .attr('id', 'slate-int-calculator-chart')

    setUpChart()

    function setUpChart () {
      const wEl = resized ? d3.select('#slate-int-calculator-output') : d3.select('#slate-int-calculator-input')
      const renderAreaW = wEl.node().getBoundingClientRect().width
      const narrow = renderAreaW < 500

      const transDur = 500
      const margin = { top: 30, right: 35, bottom: 165, left: 35 }
      const chartWidth = renderAreaW - margin.left - margin.right
      const chartHeight = (2 / 3) * chartWidth

      const x0 = d3.scaleBand()
        .rangeRound([0, chartWidth])
        .paddingInner(0)

      const x1 = d3.scaleBand()
        .domain(freqCategories)
        .paddingInner(0.5)
        .paddingOuter(0.25)

      const y = d3.scaleLinear()
        .domain([0, 1])
        .range([chartHeight, 0])

      const z = d3.scaleLinear()
        .domain([0, freqCategories.length - 1])
        .range(['rgb(160, 160, 160)', 'rgb(160, 160, 160)'])

      const svg = chartArea.append('svg')
        .attr('width', chartWidth + margin.left + margin.right)
        .attr('height', chartHeight + margin.top + margin.bottom)
        .style('margin-top', '1em')

      svg.append('svg:defs').append('svg:marker')
        .attr('id', 'triangle')
        .attr('refX', 3)
        .attr('refY', 3)
        .attr('markerWidth', 15)
        .attr('markerHeight', 15)
        .attr('orient', 'auto')
        .append('path')
        .attr('d', 'M 0 0 6 3 0 6 1.5 3')
        .style('fill', 'black')

      const chart = svg.append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)

      initChart()

      function initChart () {
        mountHeader()
        let legend
        let legendShown = false

        const xAxis = chart.append('g')
          .attr('transform', `translate(0, ${chartHeight})`)

        chart.append('g')
          .call(d3.axisLeft(y).ticks(6, '%'))
          .selectAll('text')
          .style('font-family', 'sl-Apres')

        const groups = chart.append('g')
          .attr('class', 'bar-groups')

        x0.domain([ageCategories[ageGroup]])
        let currentScale = x1.rangeRound([0, x0.bandwidth()])
        tXAxis(0)

        const initialGroup = groups.append('g')
          .attr('class', 'bar-group')
          .attr('data-group', ageIds[ageGroup])

        activeData.group = ageIds[ageGroup]

        const rects = initialGroup.selectAll('rect')
          .data(activeData.freqs).enter()
          .append('rect')
            .attr('x', (d, i) => x1(freqCategories[i]))
            .attr('y', chartHeight)
            .attr('width', x1.bandwidth())
            .attr('height', 0)
            .attr('fill', (d, i) => z(i))

        const lineG = chart.append('g')
        lineG.attr('opacity', 0)

        const line = lineG.append('line')
          .attr('marker-end', 'url(#triangle)')
          .attr('stroke', 'black')

        const you = lineG.append('text')
          .attr('dy', '-0.4em')
          .attr('font-size', '15px')
          .attr('text-anchor', 'middle')
          .text('You')

        tRect(rects)
        tLine()

        function mountHeader () {
          const ChartHeaderCtor = Vue.extend(ChartHeader)
          header = new ChartHeaderCtor({
            data: function () {
              return {
                slideData: slideData,
                currentSlide: currentSlide,
                ageGroup: ageGroup,
                hasPartner: hasPartner,
                userFreq: userFreq,
                ageCategories: ageCategories,
                freqCategories: freqCategories,
                forwardOrBack: 'forward',
                chartWidth: chartWidth,
                buttons: buttons
              }
            }
          })

          header.$mount('#slate-int-calculator-chart-header')
          header.$on('backButtonPress', () => changeSlide(false))
          header.$on('forwardButtonPress', changeSlide)
        }

        function changeSlide (advance = true) {
          currentSlide = advance ? currentSlide + 1 : currentSlide - 1
          header.currentSlide = currentSlide
          const currentSlideData = slideData[currentSlide]
          activeData = currentSlideData.data
          if (!activeData.group) activeData.group = ageIds[ageGroup]
          if (currentSlideData.multiple) return viewGroups()
          else return viewUserGroup()
        }

        function viewUserGroup () {
          x0.domain([ageCategories[ageGroup]])
          x1.rangeRound([0, x0.bandwidth()])
            .paddingInner(0.5)
          z.range(['rgb(160, 160, 160)', 'rgb(160, 160, 160)'])
          return updateChart()
        }

        function viewGroups () {
          x0.domain(ageCategories)
          x1.rangeRound([0, x0.bandwidth()])
            .paddingInner(0)
          z.range(['rgb(220, 220, 220)', 'rgb(100, 100, 100)'])
          return updateChart(true)
        }

        function updateChart (nested = false) {
          currentScale = nested ? x0 : x1
          const drawingLegend = nested && !legendShown
          const hook = drawingLegend ? 'end' : 'start'
          tXAxis().on(hook, () => {
            if (drawingLegend) drawLegend()
            else if (!nested && legendShown) removeLegend()
          })
          updateGroups()
          tLine()

          function updateGroups () {
            const groupData = nested ? activeData : [activeData]

            let oldGroups = groups.selectAll('.bar-group')

            const oldGroupsN = oldGroups.nodes().length
            const changeMode = oldGroupsN !== groupData.length

            const oldGroupTrans = tGroup(oldGroups, nested)
            oldGroupTrans.on('start', () => {
              oldGroups = oldGroups.data(groupData, function (d) { return d ? d.group : d3.select(this).attr('data-group') })
              oldGroups.exit().remove()
              updateRectGroup(oldGroups)

              if (changeMode) {
                const allGroups = oldGroups.enter()
                  .append('g')
                    .attr('class', 'bar-group')
                    .attr('data-group', (d) => d.group)
                  .merge(oldGroups)

                const allGroupTrans = tGroup(allGroups, nested)
                return allGroupTrans.on('end', () => updateRectGroup(allGroups))
              }
            })

            function updateRectGroup (rectGroup) {
              rectGroup.each(function (d, i) {
                return updateRects(d3.select(this), d.freqs)
              })
            }

            function updateRects (rects, rectData) {
              const oldRects = rects.selectAll('rect')
                .data(rectData)

              const newRects = oldRects.enter().append('rect')
                .attr('y', chartHeight)
                .attr('height', 0)
                .merge(oldRects)

              oldRects.exit().remove()

              return tRect(newRects)
            }
          }

          function drawLegend () {
            legend = chart.append('g')
              .attr('transform', `translate(0, ${chartHeight + 60})`)

            legend.append('text')
              .attr('x', 0)
              .attr('y', 15)
              .attr('dy', '0.2em')
              .text('Response:')

            const swatch = legend.selectAll('.swatch')
              .data(freqCategories).enter()
              .append('g').attr('class', 'swatch')
                .attr('transform', (d, i) => {
                  const divisor = narrow ? 2 : 5
                  const min = narrow ? 0 : 1
                  const max = narrow ? 1 : 3
                  const xMult = i < 4 ? min : max
                  const xCoord = xMult * chartWidth / divisor
                  const ySpacer = 1.2
                  const yMult = i < 4 ? i * 15 : (i - 4) * 15
                  const yMargin = narrow ? 30 : 0
                  const yCoord = ySpacer * yMult + yMargin
                  return `translate(${xCoord}, ${yCoord})`
                })

            swatch.append('rect')
              .attr('x', 0)
              .attr('y', 0)
              .attr('width', '1em')
              .attr('height', '1em')
              .style('fill', (d, i) => z(i))

            swatch.append('text')
              .attr('x', '1em')
              .attr('dx', '0.5em')
              .attr('y', '1em')
              .style('font-size', '0.8em')
              .text((d) => d)

            legendShown = true
          }

          function removeLegend () {
            legend.remove()
            legendShown = false
          }
        }

        function tRect (selection) {
          return selection.transition()
            .duration(transDur)
            .attr('x', (d, i) => x1(freqCategories[i]))
            .attr('y', (d) => y(d))
            .attr('width', x1.bandwidth())
            .attr('height', (d) => chartHeight - y(d))
            .each(function (d, i) {
              const rect = d3.select(this)
              const parentG = d3.select(this.parentNode)
              const rightAgeGroup = parentG.attr('data-group') === ageIds[ageGroup]
              const rightFreqGroup = i === userFreq
              const notLastSlide = currentSlide !== slideData.length - 1

              if (rightAgeGroup && rightFreqGroup && notLastSlide) rect.attr('fill', '#f0ff00')
              else rect.attr('fill', z(i))
            })
        }

        function tLine (duration = transDur) {
          if (currentSlide !== slideData.length - 1) {
            const youFreq = currentSlide === 3 ? d3.max(activeData[ageGroup].freqs) : activeData.freqs[userFreq]
            const youBar = currentSlide === 3 ? ageCategories[ageGroup] : freqCategories[userFreq]
            const youEdge = currentScale(youBar)
            const youMiddle = youEdge + currentScale.bandwidth() / 2
            const youHeight = y(youFreq)

            line.transition().duration(duration)
              .attr('x1', youMiddle)
              .attr('x2', youMiddle)
              .attr('y1', youHeight - 25)
              .attr('y2', youHeight - 10)

            you.transition().duration(duration)
              .attr('x', youMiddle)
              .attr('y', youHeight - 25)

            lineG.transition().duration(duration)
              .attr('opacity', 1)
          } else lineG.transition().duration(duration).attr('opacity', 0)
        }

        function tGroup (selection, multiple = false) {
          return selection.transition()
            .duration(transDur)
            .attr('transform', function () {
              if (multiple) {
                const group = d3.select(this).attr('data-group')
                return `translate(${x0(ageCategories[ageIds.indexOf(group)])}, 0)`
              } else return 'translate(0, 0)'
            })
        }

        function tXAxis () {
          return xAxis.transition().duration(transDur)
            .call(scaleAxis, currentScale)
        }

        function scaleAxis (selection) {
          selection.call(d3.axisBottom(currentScale))

          xAxis.selectAll('text')
              .attr('class', 'axis-text')
              .style('text-anchor', 'end')
              .style('font-family', 'sl-Apres')
              .attr('dx', '-.8em')
              .attr('dy', '.15em')
              .attr('transform', 'rotate(-45)')
        }
      }
    }
  }
}

// function move (arr, from, to) {
//   return arr.splice(to, 0, arr.splice(from, 1)[0])
// }

export default renderResult



// WEBPACK FOOTER //
// ./assets/Render.js